import React, { useEffect, useState } from "react";
import { PageLoader, StatusBadge, EmptyState } from "../../components/shared";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Lifebuoy } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiErr } from "../../lib/api";

export default function AdminSupport() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reply, setReply] = useState({});

  const load = () => api.get("/admin/support-tickets").then((r) => setTickets(r.data.tickets)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const update = async (id, status) => {
    try { await api.put(`/admin/support-tickets/${id}`, { status, reply: reply[id] || undefined }); toast.success("Updated."); setReply({ ...reply, [id]: "" }); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (loading) return <PageLoader />;

  return (
    <div>
      <div className="overline mb-1">Support</div>
      <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mb-6">Support Tickets</h1>
      {tickets.length === 0 ? <EmptyState icon={Lifebuoy} title="No tickets" subtitle="Customer and organizer tickets appear here." testid="no-support" /> : (
        <div className="space-y-4">
          {tickets.map((t) => (
            <div key={t.id} className="rounded-xl border border-border bg-card p-5" data-testid={`admin-ticket-${t.id}`}>
              <div className="flex items-center justify-between mb-2">
                <div><div className="font-medium">{t.subject}</div><div className="text-xs text-muted-foreground">{t.user_name} · {t.user_email}</div></div>
                <StatusBadge status={t.status} />
              </div>
              <div className="space-y-1 text-sm bg-muted/40 rounded-lg p-3 mb-3">
                {(t.messages || []).map((m, i) => <div key={i}><span className="font-medium capitalize">{m.from}:</span> {m.text}</div>)}
              </div>
              <div className="flex gap-2">
                <Textarea value={reply[t.id] || ""} onChange={(e) => setReply({ ...reply, [t.id]: e.target.value })} placeholder="Reply…" rows={1} className="flex-1" />
                <Select onValueChange={(s) => update(t.id, s)}>
                  <SelectTrigger className="w-40" data-testid={`ticket-status-${t.id}`}><SelectValue placeholder="Set status" /></SelectTrigger>
                  <SelectContent>{["in_progress", "resolved", "closed"].map((s) => <SelectItem key={s} value={s} className="capitalize">{s.replace("_", " ")}</SelectItem>)}</SelectContent>
                </Select>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
